import { WORDPRESS_API_BASE_URL } from '@/config/api';
import React, { useEffect, useState } from "react";
import MainLayout from "@/layout/MainLayout";
import HeroSection from "@/components/common/HeroSection";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    const fetchSEO = async () => {
      try {
        const res = await fetch(
          `${WORDPRESS_API_BASE_URL}/wp/v2/pages?slug=privacy-policy&_fields=yoast_head_json`
        );
        const data = await res.json();
        if (data.length > 0) {
          setSeoData(data[0].yoast_head_json);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("SEO Fetch Error:", error);
      }
    };

    fetchSEO();
  }, []);

  //  Canonical URL (safe for build & SSR)
 const canonicalUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${window.location.pathname}`
      : "https://kgkrealty.com/award";

  return (
    <MainLayout title="Privacy Policy">
      {seoData && (
        <Helmet>
          <title>{seoData.title}</title>
          <meta name="description" content={seoData.description} />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}

      <HeroSection title="Privacy Policy" />
      <div className="max-w-6xl mx-auto px-4 py-10 text-[#2A2A2A]">
        <div className="space-y-6 text-base leading-relaxed">
          <p>
            {`      Welcome to KGK Realty's Privacy Policy. We are committed to safeguarding your privacy and protecting your personal information. This Privacy Policy outlines how we collect, use, disclose, and secure your personal data when you use our website or engage with our services. By accessing our website or using our services, you agree to the practices described in this policy.
      `}
          </p>

          <h2 className="lg:text-4xl text-2xl font-normal mt-8 mb-2 text-[#0A1E2E]">Information Collection and Use</h2>
          <p>
            We may collect personal information such as your name, contact details, and other relevant information when you interact with our website or services. This information is used to provide you with better service, respond to inquiries, and enhance your experience. When you send us an email voluntarily, we keep a record of it to respond to you. We collect information from you only when you register on our site or fill out a form. While filling out a form, you may be asked to provide your name, email address, or phone number. However, you can visit our site anonymously. If you submit your personal information and contact details, we reserve the right to contact you via call, SMS, email, or WhatsApp about our products and offers, even if your number is on the Do Not Disturb (DND) list.
          </p>

          <h2 className="lg:text-4xl text-2xl font-normal mt-8 mb-2 text-[#0A1E2E]">Data Sharing and Disclosure</h2>
          <p>
            We may share your personal information with trusted third parties to fulfill your requests or improve our services. However, we do not sell, rent, or trade your personal information to third parties for marketing purposes.
          </p>

          <h2 className="lg:text-4xl text-2xl font-normal mt-8 mb-2 text-[#0A1E2E]">Data Security</h2>
          <p>
            We take reasonable measures to protect your personal information from unauthorized access, alteration, or disclosure. However, no data transmission over the internet can be guaranteed as 100% secure. Therefore, while we strive to protect your information, we cannot ensure or warrant the security of any information you transmit to us.
          </p>

          <h2 className="lg:text-4xl text-2xl font-normal mt-8 mb-2 text-[#0A1E2E]">Cookies</h2>
          <p>
            Our website may use cookies to enhance your browsing experience. These cookies collect non-personal information and are used to analyze website traffic and user behavior. You can adjust your browser settings to refuse cookies or alert you when cookies are being sent.
          </p>

          <h2 className="lg:text-4xl text-2xl font-normal mt-8 mb-2 text-[#0A1E2E]">Links to Other Websites</h2>
          <p>
            Our website may contain links to external sites that are not operated by us. We have no control over the content or practices of these sites and are not responsible for their privacy policies or practices.
          </p>

          <h2 className="lg:text-4xl text-2xl font-normal mt-8 mb-2 text-[#0A1E2E]">Updates to Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this policy periodically.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPolicy;